enum NomyxEvent {
  ClaimTopicAdded = "ClaimTopicAdded",
  ClaimTopicRemoved = "ClaimTopicRemoved",
  TrustedIssuerAdded = "TrustedIssuerAdded",
  TrustedIssuerRemoved = "TrustedIssuerRemoved",
  ClaimTopicsUpdated = "ClaimTopicsUpdated",
  ClaimRequested = "ClaimRequested",
  ClaimAdded = "ClaimAdded",
  ClaimRemoved = "ClaimRemoved",
  IdentityAdded = "IdentityAdded",
  IdentityRemoved = "IdentityRemoved",
  IdentityCountryUpdated = "IdentityCountryUpdated",
  WalletLinked = "WalletLinked",
  WalletUnlinked = "WalletUnlinked",
  AssociateInquiry = "AssociateInquiry",
}

enum NomyxAction {
  CreateClaimTopic,
  ViewClaimTopic,
  EditClaimTopic,
  RemoveClaimTopic,
  CreateTrustedIssuer,
  RemoveTrustedIssuer,
  UpdateClaimTopics,
  CreateIdentity,
  CreatePendingIdentity,
  ViewIdentity,
  RequestInvestment,
  ViewPendingIdentity,
  RemoveIdentity,
  DenyUser,
  EditClaims,
  AddClaims,
  AssociateInquiry,
  SendVerificationEmail,
  ResetPersonaVerification,
  MoveToUnderReview,
  MoveToTester,
  MoveToReviewer,
  ViewTrustedIssuer,
  MoveToPending,
  RevokeReviewer,
  SuspendIdentity,
  UnsuspendIdentity,
}

enum WalletPreference {
  MANAGED,
  PRIVATE,
}

// Read-only "view" actions a Reviewer is allowed to see/use in list views.
// Everything else (create/edit/remove/approve/move/etc.) is hidden for reviewers.
const ReviewerAllowedActions = [NomyxAction.ViewClaimTopic, NomyxAction.ViewIdentity, NomyxAction.ViewPendingIdentity, NomyxAction.ViewTrustedIssuer];

export { NomyxEvent, NomyxAction, WalletPreference, ReviewerAllowedActions };
